document.addEventListener("DOMContentLoaded", () => {


    const tabs = document.querySelectorAll('.create-your-kit-filter ul li');
    const collections = document.querySelectorAll('.create-your-kit-collection');

    const initCollection = (collection) => {
        const swipers = collection.querySelectorAll('.create-your-kit-swiper');
        swipers.forEach((swiper) => {
            const dataSwiper = swiper.getAttribute('data-swiper');

            const create_your_kit_swiper = new window.swiper(`.create-your-kit-swiper.${dataSwiper}`, {
                slidesPerView: 1.3,
                spaceBetween: 44,
                lazy: {
                    enabled: true,
                    checkInView: true,
                    loadOnTransitionStart: true,
                    loadPrevNext: true,
                    loadPrevNextAmount: 1
                    },
                    navigation: {
                        nextEl: `.swiper-button-next.${dataSwiper}`,
                        prevEl: `.swiper-button-prev.${dataSwiper}`,
                        },
                        breakpoints: {
                            450: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                        },
                        600: {
                            slidesPerView: 3,
                            spaceBetween: 20,
                            },
                    900: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                        },
                        1280: {
                            slidesPerView: 4,
                            spaceBetween: 20,
                            },
                },
                scrollbarHide: false,
                updateOnImagesReady: true,
                runCallbacksOnInit: true,
                observer: true
                });
                });

                // Tabs
                const filter = collection.querySelector(`.swiper-filter`);
                const product = collection.querySelector(`.swiper-product`);

                filter.addEventListener('click', (event) => {
                    const target = event.target;
                    if (target.matches('li')) {
                const filterValue = target.getAttribute('data-filter');

                if (filterValue === '.all') {
                    product.querySelectorAll('.swiper-slide').forEach((slide) => {
                        slide.style.display = '';
                        });
                        } else {
                            product.querySelectorAll('.swiper-slide').forEach((slide) => {
                                slide.style.display = 'none';
                                });

                                product.querySelectorAll(`.swiper-slide${filterValue}`).forEach((slide) => {
                                    slide.style.display = '';
                                    });
                                    }

                                    filter.querySelectorAll('li').forEach((link) => {
                                        link.classList.remove('active');
                                        });

                                        target.classList.add('active');

                                        if (create_your_kit_swiper) {
                                            create_your_kit_swiper.update();
                                            }

                                            return false;
                                            }
                                            });
    };

    collections.forEach(initCollection);

    const clickTab = (tabs, index) => {
        tabs.forEach((tab, i) => {
            if (i === index) {
                tab.classList.add('active');
                tab.querySelector('a').click();
            } else {
                tab.classList.remove('active');
        }
    });
};

tabs.forEach((tab, i) => {
    tab.addEventListener('click', (event) => {
        event.preventDefault();
        clickTab(tabs, i);

        // Hide all content blocks
        const contentBlocks = document.querySelectorAll('.create-your-kit-row');
        contentBlocks.forEach((content) => {
            content.style.display = 'none';
            });

            // Show the content block associated with the clicked tab
            const tabValue = tab.querySelector('a').textContent.trim().toLowerCase().replace(/ /g, '-');
            const activeContentBlock = document.querySelector(`.create-your-kit-row[data-tab-content="${tabValue}"]`);

            if (activeContentBlock) {
                activeContentBlock.style.display = 'block';
        }

        // Trigger the click event for the first tab
        if (i === 0) {
            clickTab(tabs, 0);
        }
    });
});

                // Is this cheating? Maybe. Does it work though? Yes.
    clickTab(tabs, 0);
// Get url param type and select the below tabs
const urlParams = new URLSearchParams(window.location.search);
const type = urlParams.get('type');

if (type) {
    console.log(type);
    const filter_headings = document.querySelectorAll('.create-your-kit-filter ul li a');
    filter_headings.forEach((heading,i) => {
        if (heading.textContent.trim().toLowerCase().replace(/ /g, '-') === type) {
            console.log("Heading",i);
            clickTab(tabs, i);
        }
    });
}
});

